import Marquee from "react-fast-marquee";

const ITEMS = ["EVERY DRIVE BUILDS OWNERSHIP", "RENTALS", "RENT TO OWN", "SALES", "NO HIDDEN BALLOON"];

export default function EditorialMarquee() {
  return (
    <section data-testid="editorial-marquee" className="py-14 border-y border-sky-300/10 overflow-hidden bg-[#0A1C45]">
      <Marquee speed={35} gradient={false} pauseOnHover>
        {ITEMS.concat(ITEMS).map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display text-6xl md:text-8xl font-black text-outline tracking-tight whitespace-nowrap px-6">
              {item}
            </span>
            <span className="text-[#F57C00] text-3xl md:text-5xl px-2">•</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
